import {
  GET_PROFILE,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAILURE,
  UPDATE_PROFILE_DATA,
  UPDATE_PROFILE_DATA_SUCCESS,
  UPDATE_PROFILE_DATA_FAILURE,
} from "../../Actions/types";

const initialState = {
  getLoader: false,
  getError: false,
  getData: null,
  updateLoader: false,
  updatedData: null,
  updateError: false
};
function profileReducer(state = initialState, action) {

  switch (action.type) {
    case GET_PROFILE:
      return {...state, getLoader: true};
    case GET_PROFILE_SUCCESS:
      return { ...state, getData: action?.payload, getLoader: false };
    case GET_PROFILE_FAILURE:
      return { ...state, getLoader: false, getError: true };

    case UPDATE_PROFILE_DATA:
      return { ...state, updateLoader: true };
    case UPDATE_PROFILE_DATA_SUCCESS:
      return { ...state, updatedData: action?.payload, updateLoader: false };
    case UPDATE_PROFILE_DATA_FAILURE:
      return { ...state, updateError: true, updateLoader: false };

    default:
      return state;
  }
}

export default profileReducer;
